module.exports = __webpack_public_path__ + "img/sdg7_id.7555d9a7.svg";